export default {
      id: "spin-control-active-usage",
      viewBox: "0 0 480.04 480.46",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#spin-control-active-usage",
      toString: function () {
        return this.url;
      }
    }